import React, { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';

export default function Home() {
  useEffect(() => {
    const sr = ScrollReveal({
      origin: 'top',
      distance: '60px',
      duration: 2500,
      delay: 400,
      // reset: true
    });
    sr.reveal(`.home__perfil, .about__image, .contact__mail`, { origin: 'right' });
    sr.reveal(`.home__name, .home__info,
      .about__container .section__title-1, .about__info,
      .contact__social, .contact__data`, { origin: 'left' });
  }, []);

  return (
    <section className="home section" id="home">
      <div className="home__container container grid">
        <h1 className="home__name">Traki</h1>

        <div className="home__perfil">
          <div className="home__image">
            <img src="../../assets/tregoimg-removebg.png" alt="image" className="home__img" />
            <div className="home__shadow"></div>

            <img src="../../assets/curved-arrow.svg" alt="arrow" className="home__arrow" />

            <div className="geometric-box"></div>
          </div>

        </div>

        <div className="home__info">
          <p className="home__description ">
<b>Traki</b> is your <b>all-in-one </b>digital <b>command center</b> — built to manage <b>members</b>,  <b>monitor records</b>, <b>automate workflows</b>, and  <b>simplify daily operations</b> with <b>precision</b> and ease.
          </p>
          <a href="#about" className="home__scroll">
            <div className="home__scroll-box">
              <i className="ri-arrow-down-s-line"></i>
            </div>
            <span className="home__scroll-text">Scroll Down</span>
          </a>
          <br />
          One Platform. Total Control. Complete Confidence.
        </div>
      </div>
    </section>
  );
}
